import React from "react";
import { Box, Typography } from "@mui/material";

const ExpedicaoActions = ({ totalItems }) => {
  if (totalItems === 0) return null;

  return (
    <Box
      sx={{
        backgroundColor: "white",
        p: 3,
        borderTop: "1px solid rgba(0,0,0,0.1)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Typography variant="body2" color="#666" sx={{ fontWeight: 500 }}>
        Total: {totalItems} {totalItems === 1 ? 'item' : 'itens'}
      </Typography>
    </Box>
  );
};

export default ExpedicaoActions;